import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
Vue.use(ElementUI, {locale})
// 全ての画面で仕様するパッケージ
require('bootstrap');
require('popper.js');
require('babel-polyfill')
require('jquery-confirm');
require('jquery-ui');
require('jquery-ui-bundle');
require('jquery-ui-touch-punch');
require('sprintf-js');

require('js/public/common_component.js');

import pkginfo from 'js/../../../package.json';
console.log(`Version: ${pkginfo.version}`);

import {UPDATE_TYPE} from 'js/const/constants';
import {LIST_BASE} from 'js/const/constants';

Vue.mixin({
	computed:{
		// 定数
		UPDATE_TYPE_ADD: function(){ return UPDATE_TYPE.UPDATE_TYPE_ADD },	// 新規登録
		UPDATE_TYPE_UP: function(){ return UPDATE_TYPE.UPDATE_TYPE_UP },	// データ更新
		UPDATE_TYPE_DEL: function(){ return UPDATE_TYPE.UPDATE_TYPE_DEL },	// データ消去
		INITIAL_SORT_ID: function(){ return LIST_BASE.INITIAL_SORT_ID },
		INITIAL_PAGE_NO: function(){ return LIST_BASE.INITIAL_PAGE_NO },
		RESULT_NUM: function(){ return LIST_BASE.RESULT_NUM },
		COMMON: function(){
			if (this.$store.state.common) {
				return this.$store.state.common;
			}
			return {};
		},
		USER_MAIL_ADDRESS_MAX: function(){ return 100 },
	},
});

// session storageに保存しているスクロール位置を削除する
console.log('>>> remove session storage [key: labelplus_scroll_offset]');
sessionStorage.removeItem('labelplus_scroll_offset');


// WEBPACK FOOTER //
// ./resources/assets/js/public/application.js